module.exports = __webpack_public_path__ + "img/garden_glzz_2.ae3ecf0f.png";